import React from 'react';
import { Text, VSpacer } from '@/components/DesignSystem';
import { Box, Stack } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

interface ExpandableFilterBoxProps {
  children: React.ReactNode,
  isExpanded: boolean,
  onToggle: () => void,
  summaryContent?: React.ReactNode,
  title: string,
}

export const ExpandableFilterBox = ({
  children,
  isExpanded,
  onToggle,
  summaryContent,
  title,
}: ExpandableFilterBoxProps) => {
  return (
    <Box
      onClick={onToggle}
      sx={(theme) => ({
        padding: "14px 16px",
        border: summaryContent
          ? `1px solid ${theme.palette.primary.main}`
          : '1px solid rgba(0, 0, 0, 0.12)',
        boxShadow: summaryContent
          ? `0 0 0 1px ${theme.palette.primary.main}`
          : 'none',
        borderRadius: 2,
        width: '100%',
        backgroundColor: 'white',
        cursor: 'pointer',
      })}
    >
      <Stack
        alignItems="flex-start"
        direction="row"
      >
        <Text category="body-large" sx={{ flexShrink: 0, pt: '2px' }}>{title}</Text>
        <Box sx={{ flex: 1 }} />
        {!isExpanded && summaryContent}
        <KeyboardArrowUpIcon
          color="primary"
          sx={{
            flexShrink: 0,
            ml: 1,
            transform: isExpanded ? 'rotate(0deg)' : 'rotate(180deg)',
            transition: 'transform 200ms ease',
          }}
        />
      </Stack>
      {isExpanded && (
        <Box onClick={(event) => event.stopPropagation()} sx={{ cursor: 'default' }}>
          <VSpacer size="5" />
          {children}
        </Box>
      )}
    </Box>
  );
};
